import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const ShareholderGroups = React.lazy(() => import('./index'));
const ShareholderGroupTable = React.lazy(() => import('./shareholderGroupTable'));
const ShareholderGroup = React.lazy(() => import('./shareholderGroup'));
const ShareholderGroupDetail = React.lazy(() => import('./shareholderGroupDetail'));
const AddNewShareholderGroup = React.lazy(() => import('./addNewShareholderGroup'));
const EditShareholderGroup = React.lazy(() => import('./editShareholderGroup'));

export const useShareholderGroupRoutes = () => {

    return (
        <Route path="shareholderGroups" element={<Suspense fallback={<div>منتظر باشید...</div>}><ShareholderGroups /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ShareholderGroupTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewShareholderGroup/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><ShareholderGroup/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ShareholderGroupDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditShareholderGroup/></Suspense> } />
            </Route>
        </Route>
    )
}